module.exports = "4e47f6b56c910d7399aebbcd82b2da3a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-l-2.png
// module id = 55
// module chunks = 0